export const UNIT_DETAILS_GRID_CONFIG_ID = 'unit-dash-unit-details'

export const UNIT_DETAILS_GRID_CONFIG = {
  id: UNIT_DETAILS_GRID_CONFIG_ID,
  layout: {
    xxl: { i: UNIT_DETAILS_GRID_CONFIG_ID, x: 3.25, y: 0, w: 5, h: 3.15, static: true },
    xl: { i: UNIT_DETAILS_GRID_CONFIG_ID, x: 4, y: 0, w: 6, h: 3.15, static: true },
    lg: { i: UNIT_DETAILS_GRID_CONFIG_ID, x: 4.5, y: 0, w: 6, h: 3.35, static: true },
    md: { i: UNIT_DETAILS_GRID_CONFIG_ID, x: 5, y: 0, w: 7, h: 3.25, static: true },
    sm: { i: UNIT_DETAILS_GRID_CONFIG_ID, x: 5.75, y: 0, w: 6.25, h: 3.25, static: true },
    xs: { i: UNIT_DETAILS_GRID_CONFIG_ID, x: 7, y: 0, w: 5.35, h: 5, static: true },
    xxs: { i: UNIT_DETAILS_GRID_CONFIG_ID, x: 0, y: 1.75, w: 12, h: 1.75, static: true }
  }
}
